module.exports = __webpack_public_path__ + "img/1.bb4e8327.png";